import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("quilla_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setSession(r.data))
      .catch(() => localStorage.removeItem("quilla_token"))
      .finally(() => setLoading(false));
    // Bootstrap único al montar la app: api es singleton, setSession/setLoading son estables.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (license, pin) => {
    const { data } = await api.post("/auth/login", { license, pin });
    localStorage.setItem("quilla_token", data.token);
    setSession({ user: data.user, hotel: data.hotel });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("quilla_token");
    setSession(null);
  };

  return (
    <AuthCtx.Provider value={{ session, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
